//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OddsTable from '../components/OddsTable'

export default {
    name: 'CorrectScore',
    components: {
        OddsTable
    }
}
